import toFixed from 'accounting-js/lib/toFixed.js';

var prevField = null;

export const handleAmount = (
  key,
  amount,
  parentName,
  setValue,
  getValues,
  calculationValues
) => {
  if (!handleField(key, amount, calculationValues)) {
    return;
  }

  let sum = getValues(parentName ? parentName.concat('.sum') : 'sum');

  let price = getValues(parentName ? parentName.concat('.price') : 'price');

  if (price && !isNaN(price) && amount && prevField === 'price') {
    sum = calculateSum(price, amount);

    handleSetValues(
      'sum',
      sum,
      setValue,
      parentName,
      getValues,
      calculationValues
    );

    let vat_rate = getValues(
      parentName ? parentName.concat('.vat_rate') : 'vat_rate'
    );

    if (vat_rate?.rate && sum) {
      let vat = calculateVat(sum, vat_rate.rate);
      handleSetValues(
        'vat',
        vat,
        setValue,
        parentName,
        getValues,
        calculationValues
      );

      let sum_with_vat = calculateVatWithSum(sum, vat);
      handleSetValues(
        'sum_with_vat',
        sum_with_vat,
        setValue,
        parentName,
        getValues,
        calculationValues
      );
    }
  } else if (sum && amount) {
    price = calculatePrice(sum, amount);

    handleSetValues(
      'price',
      price,
      setValue,
      parentName,
      getValues,
      calculationValues
    );
  }
};

export const handlePrice = (
  key,
  price,
  parentName,
  setValue,
  getValues,
  calculationValues
) => {
  if (!handleField(key, price, calculationValues)) {
    return;
  }

  let sum = getValues(parentName ? parentName.concat('.sum') : 'sum');

  let amount = getValues(parentName ? parentName.concat('.amount') : 'amount');

  if (price && amount) {
    sum = calculateSum(price, amount);

    handleSetValues(
      'sum',
      sum,
      setValue,
      parentName,
      getValues,
      calculationValues
    );

    let vat_rate = getValues(
      parentName ? parentName.concat('.vat_rate') : 'vat_rate'
    );

    if (vat_rate?.rate) {
      let vat = calculateVat(sum, vat_rate.rate);
      handleSetValues(
        'vat',
        vat,
        setValue,
        parentName,
        getValues,
        calculationValues
      );

      let sum_with_vat = calculateVatWithSum(sum, vat);
      handleSetValues(
        'sum_with_vat',
        sum_with_vat,
        setValue,
        parentName,
        getValues,
        calculationValues
      );
    }
  }

  prevField = key;
};

export const handleSum = (
  key,
  sum,
  parentName,
  setValue,
  getValues,
  calculationValues
) => {
  if (!handleField(key, sum, calculationValues)) {
    return;
  }

  let price = getValues(parentName ? parentName.concat('.price') : 'price');

  let amount = getValues(parentName ? parentName.concat('.amount') : 'amount');

  let vat_rate = getValues(
    parentName ? parentName.concat('.vat_rate') : 'vat_rate'
  );

  let vat = getValues(parentName ? parentName.concat('.vat') : 'vat');

  let sum_with_vat = getValues(
    parentName ? parentName.concat('.sum_with_vat') : 'sum_with_vat'
  );

  if (vat_rate?.rate && sum) {
    vat = calculateVat(sum, vat_rate.rate);

    handleSetValues(
      'vat',
      vat,
      setValue,
      parentName,
      getValues,
      calculationValues
    );
  }

  if (amount && sum) {
    price = calculatePrice(sum, amount);

    handleSetValues(
      'price',
      price,
      setValue,
      parentName,
      getValues,
      calculationValues
    );
  }

  if (vat && sum) {
    sum_with_vat = calculateVatWithSum(sum, vat);

    handleSetValues(
      'sum_with_vat',
      sum_with_vat,
      setValue,
      parentName,
      getValues,
      calculationValues
    );
  }

  prevField = key;
};

export const handleVatRate = (
  key,
  vatRate,
  parentName,
  setValue,
  getValues,
  calculationValues
) => {
  if (!handleField(key, vatRate.rate, calculationValues)) {
    return;
  }

  let sum = getValues(parentName ? parentName.concat('.sum') : 'sum');

  let vat = getValues(parentName ? parentName.concat('.vat') : 'vat');

  let sum_with_vat = getValues(
    parentName ? parentName.concat('.sum_with_vat') : 'sum_with_vat'
  );

  if (vatRate?.rate && sum) {
    vat = calculateVat(sum, vatRate.rate);

    handleSetValues(
      'vat',
      vat,
      setValue,
      parentName,
      getValues,
      calculationValues
    );
  } else if (sum_with_vat && vatRate?.rate) {
    vat = calculateVatWithVatRate(sum_with_vat, vatRate.rate);

    handleSetValues(
      'vat',
      vat,
      setValue,
      parentName,
      getValues,
      calculationValues
    );

    sum = calculateSumFromVat(sum_with_vat, vat);

    handleSetValues(
      'sum',
      sum,
      setValue,
      parentName,
      getValues,
      calculationValues
    );

    let amount = getValues(
      parentName ? parentName.concat('.amount') : 'amount'
    );

    let price = getValues(parentName ? parentName.concat('.price') : 'price');

    if (price && amount) {
      price = calculatePrice(sum, amount);

      handleSetValues(
        'price',
        price,
        setValue,
        parentName,
        getValues,
        calculationValues
      );
    }

    if (!price && amount) {
      price = calculatePrice(sum, amount);

      handleSetValues(
        'price',
        price,
        setValue,
        parentName,
        getValues,
        calculationValues
      );
    }
  }

  if (vat && sum) {
    sum_with_vat = calculateVatWithSum(sum, vat);

    handleSetValues(
      'sum_with_vat',
      sum_with_vat,
      setValue,
      parentName,
      getValues,
      calculationValues
    );
  }

  prevField = key;
};

export const handleVat = (
  key,
  vat,
  parentName,
  setValue,
  getValues,
  calculationValues
) => {
  if (!handleField(key, vat, calculationValues)) {
    return;
  }

  let sum = getValues(parentName ? parentName.concat('.sum') : 'sum');

  let sum_with_vat = getValues(
    parentName ? parentName.concat('.sum_with_vat') : 'sum_with_vat'
  );

  if (vat && sum_with_vat) {
    sum = calculateSumFromVat(sum_with_vat, vat);

    handleSetValues(
      'sum',
      sum,
      setValue,
      parentName,
      getValues,
      calculationValues
    );

    let amount = getValues(
      parentName ? parentName.concat('.amount') : 'amount'
    );

    if (amount && amount) {
      let price = calculatePrice(sum, amount);

      handleSetValues(
        'price',
        price,
        setValue,
        parentName,
        getValues,
        calculationValues
      );
    }
  }

  if (vat && sum) {
    sum_with_vat = calculateVatWithSum(sum, vat);

    handleSetValues(
      'sum_with_vat',
      sum_with_vat,
      setValue,
      parentName,
      getValues,
      calculationValues
    );
  }

  prevField = key;
};

export const handleSumWithVat = (
  key,
  sumWithVat,
  parentName,
  setValue,
  getValues,
  calculationValues
) => {
  if (!handleField(key, sumWithVat, calculationValues)) {
    return;
  }

  let vat_rate = getValues(
    parentName ? parentName.concat('.vat_rate') : 'vat_rate'
  );

  let sum = getValues(parentName ? parentName.concat('.sum') : 'sum');

  let vat = getValues(parentName ? parentName.concat('.vat') : 'vat');

  if (sumWithVat && vat_rate?.rate) {
    vat = calculateVatWithVatRate(sumWithVat, vat_rate.rate);

    handleSetValues(
      'vat',
      vat,
      setValue,
      parentName,
      getValues,
      calculationValues
    );
  }

  if (sumWithVat && vat) {
    sum = calculateSumFromVat(sumWithVat, vat);

    handleSetValues(
      'sum',
      sum,
      setValue,
      parentName,
      getValues,
      calculationValues
    );
  }

  let amount = getValues(parentName ? parentName.concat('.amount') : 'amount');

  let price = getValues(parentName ? parentName.concat('.price') : 'price');

  if (price && amount) {
    price = calculatePrice(sum, amount);

    handleSetValues(
      'price',
      price,
      setValue,
      parentName,
      getValues,
      calculationValues
    );
  }

  if (!price && amount) {
    price = calculatePrice(sum, amount);

    handleSetValues(
      'price',
      price,
      setValue,
      parentName,
      getValues,
      calculationValues
    );
  }

  prevField = key;
};

export const handlePackagingSize = (
  key,
  size,
  parentName,
  setValue,
  getValues,
  calculationValues
) => {
  const packaging_amount = getValues(
    parentName ? parentName.concat('.packaging_amount') : 'packaging_amount'
  );

  if (packaging_amount && size) {
    setValue(
      parentName ? parentName.concat('.amount') : 'amount',
      toFixed(parseFloat(size) * parseFloat(packaging_amount), 2)
    );
  }
};

export const handlePackagingUnit = (parentName, setValue, getValues) => {
  const packagingUnit = getValues(
    parentName ? parentName.concat('.packaging_unit') : 'packaging_unit'
  );

  if (packagingUnit) {
    setValue(parentName ? parentName.concat('.unit') : 'unit', packagingUnit);
  }
};

export const handlePackagingAmount = (
  key,
  amount,
  parentName,
  setValue,
  getValues,
  calculationValues
) => {
  const packaging_size = getValues(
    parentName ? parentName.concat('.packaging_size') : 'packaging_size'
  );

  if (packaging_size && amount) {
    setValue(
      parentName ? parentName.concat('.amount') : 'amount',
      toFixed(parseFloat(amount) * parseFloat(packaging_size), 2)
    );
  }
};

const handleField = (key, value, calculationValues) => {
  if (calculationValues[key] === value || isNaN(value)) {
    return false;
  }
  calculationValues[key] = value;
  return true;
};

const calculatePrice = (sum, amount) => {
  // (SUM /  AMOUNT) = PRICE
  return toFixed(parseFloat(sum) / parseFloat(amount), 4);
};

const calculateSum = (price, amount) => {
  // (PRICE * AMOUNT) = SUM
  return toFixed(parseFloat(price) * parseFloat(amount), 2);
};

const calculateSumFromVat = (sumWithVat, vat) => {
  // (SUM_WITH_VAT – VAT) = SUM
  return toFixed(parseFloat(sumWithVat) - parseFloat(vat), 2);
};

const calculateVat = (sum, vatRate) => {
  // (SUM * (VAT_RATE/100)) = VAT
  return toFixed(parseFloat(sum) * (parseFloat(vatRate) / 100), 2);
};

const calculateVatWithVatRate = (sumWithVat, vatRate) => {
  // (SUM_WITH_VAT * VAT_RATE/ (100 + VAT_RATE)) = VAT
  return toFixed(
    parseFloat(sumWithVat) *
      (parseFloat(vatRate) / (100 + parseFloat(vatRate))),
    2
  );
};

const calculateVatWithSum = (sum, vat) => {
  // (SUM + VAT) = SUM_WITH_VAT
  return toFixed(parseFloat(sum) + parseFloat(vat), 2);
};

const handleSetValues = (
  key,
  value,
  setValue,
  parentName,
  getValues,
  calculationValues
) => {
  if (calculationValues[key] !== value) {
    calculationValues[key] = value;
    return setValue(parentName ? parentName.concat('.', key) : key, value);
  }

  let formValue = getValues(parentName ? parentName.concat('.', key) : key);

  if (formValue !== value) {
    return setValue(parentName ? parentName.concat('.', key) : key, value);
  }
};
